<template>
  <span>
    <button class="btn btn-primary-small rounded-pill px-5 py-3" v-b-modal.programme-modal>
      <i class="fa fa-plus fa-lg mr-3"></i>
      {{ trans('programme.register') }}
    </button>
    <b-modal
      id="programme-modal"
      @shown="loadOrganiser"
      @hide="resetModal"
      hide-header
      body-class="pb-5 pt-0"
    >
      <template v-slot:default>
        <div class="row bg-light-blue">
          <div class="col-lg-12">
            <div class="p-3">
              <h3 class="font-green">{{ trans('programme.register_modal_title') }}</h3>
              <p class="mb-2">{{ trans('programme.register_modal_subtitle') }}</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <form class="px-3 py-4">
              <div class="form-group">
                <label for>{{ trans('programme.organiser') }}</label>
                <select
                  v-model="selected.agency_id"
                  @change="loadProgramme()"
                  class="form-control form-control-lg border-0 bg-gray"
                >
                  <option :value="null">{{ trans('programme.organiser_select') }}</option>
                  <option
                    v-for="organiser in organisers"
                    :key="organiser.id"
                    :value="organiser.id"
                  >{{ organiser.name }}</option>
                </select>
              </div>
              <div class="form-group">
                <label for>{{ trans('programme.programme_name') }}</label>
                <select
                  v-model="selected.programme_id"
                  @change="loadSchedule()"
                  class="form-control form-control-lg border-0 bg-gray"
                >
                  <option :value="null">{{ trans('programme.programme_select') }}</option>
                  <option
                    v-for="programme in programmes"
                    :key="programme.id"
                    :value="programme.id"
                  >{{ programme.name }}</option>
                </select>
              </div>
              <div class="form-group">
                <label for>{{ trans('programme.state') }}</label>
                <select
                  v-model="selected.schedule_id"
                  @change="loadScheduleTime()"
                  class="form-control form-control-lg border-0 bg-gray"
                >
                  <option :value="null">{{ trans('programme.state_select') }}</option>
                  <option
                    v-for="schedule in schedules"
                    :key="schedule.id"
                    :value="schedule.id"
                  >{{ schedule.state.name }}</option>
                </select>
              </div>
              <div class="form-group">
                <label for>{{ trans('programme.date') }}</label>
                <select
                  v-model="selected.schedule_time_id"
                  class="form-control form-control-lg border-0 bg-gray"
                >
                  <option :value="null">{{ trans('programme.date_select') }}</option>
                  <option
                    v-for="schedules_time in schedules_times"
                    :key="schedules_time.id"
                    :value="schedules_time.id"
                  >
                    {{
                    schedules_time.started_at
                    | moment("DD MMMM YYYY")
                    }}
                    -
                    {{
                    schedules_time.ended_at
                    | moment("DD MMMM YYYY")
                    }}
                  </option>
                </select>
              </div>
            </form>
          </div>
        </div>
      </template>
      <template v-slot:modal-footer="{  cancel }">
        <button type="button" class="btn mr-3" @click="cancel()">{{ trans('programme.cancel') }}</button>
        <button
          type="button"
          class="btn btn-primary px-5"
          @click="handleOk()"
        >{{ trans('programme.join') }}</button>
      </template>
    </b-modal>
  </span>
</template>

<script>
export default {
  data() {
    return this.initData();
  },
  methods: {
    initData() {
      return {
        organisers: [],
        programmes: [],
        schedules: [],
        schedules_times: [],
        selected: {
          agency_id: null,
          programme_id: null,
          schedule_id: null,
          schedule_time_id: null,
        },
      };
    },
    async loadOrganiser() {
      let loader = this.$loading.show();
      try {
        const { data } = await axios.get(route("api.agencies.index"));
        this.organisers = data;
        loader.hide();
      } catch (e) {
        loader.hide();
        this.errorPopup(e.response.data.message);
      }
    },
    async loadProgramme() {
      let loader = this.$loading.show();
      this.selected.programme_id = this.initData().selected.programme_id;
      this.selected.schedule_id = this.initData().selected.schedule_id;
      this.selected.schedule_time_id = this.initData().selected.schedule_time_id;
      this.programmes = this.initData().programmes;
      this.schedules = this.initData().schedules;
      this.schedules_times = this.initData().schedules_times;
      try {
        const { data } = await axios.post(route("api.programmes.list"), {
          agency_id: this.selected.agency_id,
        });
        this.programmes = data;
        loader.hide();
      } catch (e) {
        loader.hide();
        this.errorPopup(e.response.data.message);
      }
    },
    async loadSchedule() {
      let loader = this.$loading.show();
      this.selected.schedule_id = this.initData().selected.schedule_id;
      this.selected.schedule_time_id = this.initData().selected.schedule_time_id;
      this.schedules = this.initData().schedules;
      this.schedules_times = this.initData().schedules_times;
      try {
        const { data } = await axios.post(route("api.schedules.list"), {
          programme_id: this.selected.programme_id,
        });
        this.schedules = data;
        loader.hide();
      } catch (e) {
        loader.hide();
        this.errorPopup(e.response.data.message);
      }
    },
    async loadScheduleTime() {
      let loader = this.$loading.show();
      this.selected.schedule_time_id = this.initData().selected.schedule_time_id;
      this.schedules_times = this.initData().schedules_times;
      try {
        const { data } = await axios.post(route("api.schedules.times"), {
          schedule_id: this.selected.schedule_id,
        });
        this.schedules_times = data;
        loader.hide();
      } catch (e) {
        loader.hide();
        this.errorPopup(e.response.data.message);
      }
    },
    handleOk() {
      this.submit_store();
    },
    async submit_store() {
      console.log("submit");
      let loader = this.$loading.show();
      try {
        const { data } = await axios.post(route("api.programmes.participate"), {
          selected: this.selected,
        });
        loader.hide();
        this.successSwal();
        this.$bvModal.hide("programme-modal");
        if (typeof window.reloadTable == "function") {
          reloadTable();
        }
      } catch (e) {
        loader.hide();
        this.errorPopup(e.response.data.message);
      }
      // }
    },
    resetModal() {
      this.selected = this.initData().selected;
      this.organisers = this.initData().organisers;
      this.programmes = this.initData().programmes;
      this.schedules = this.initData().schedules;
      this.schedules_times = this.initData().schedules_times;
    },
  },
};
</script>
